import * as RP from '@radix-ui/react-popover'
import type { ComponentProps } from 'react'
import { cn } from './cn'
import { floatingPanel } from './popover-styles'
import { usePrivateAttrs } from './privateArea'

export const Popover = RP.Root
export const PopoverTrigger = RP.Trigger
export const PopoverAnchor = RP.Anchor
export const PopoverClose = RP.Close

export interface PopoverContentProps extends ComponentProps<typeof RP.Content> {
  /** Width in px (default auto). */
  width?: number
  /** Inner padding: none for lists that manage their own (default md = 12px). */
  padding?: 'none' | 'sm' | 'md'
}

const paddings = { none: '', sm: 'p-1.5', md: 'p-3' }

/** Floating panel (surface, 1px line, radius 12, shadow pop). */
export function PopoverContent({
  className,
  width,
  padding = 'md',
  sideOffset = 8,
  collisionPadding = 8,
  align = 'center',
  style,
  ...rest
}: PopoverContentProps) {
  const priv = usePrivateAttrs()
  return (
    <RP.Portal>
      <RP.Content
        sideOffset={sideOffset}
        collisionPadding={collisionPadding}
        align={align}
        className={cn(floatingPanel, 'max-w-[calc(100vw-16px)]', paddings[padding], className)}
        style={{ width, ...style }}
        {...priv}
        {...rest}
      />
    </RP.Portal>
  )
}
